import styled from 'styled-components';
import { Avatar } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { meta } from '../../../constants';
import { Link } from '../../lib/components';
import { useHeaderData } from '../helpers';

export function HeaderAvatar() {
  const { provider } = meta;
  const { image = '', name = '', url = '' } = useHeaderData();

  return (
    <AvatarLink
      href={url}
      aria-label={`Visit ${name || 'user'}'s profile on ${
        provider || 'social media'
      }`}
    >
      <StyledAvatar src={image} size={40} altText={name} />
    </AvatarLink>
  );
}

const AvatarLink = styled(Link).attrs({
  className: createReadableClass({
    component: 'header-avatar',
    element: 'link'
  })
})`
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  width: fit-content;
  border-radius: 50%;
  display: flex;
  align-items: center;
`;

const StyledAvatar = styled(Avatar).attrs({
  className: createReadableClass({
    component: 'header-avatar'
  })
})`
  &::after {
    content: '';
    cursor: pointer;
    position: absolute;
    inset: 0;
    background-color: rgba(17, 17, 17, 0.1);
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: inherit;
  }

  &:hover::after {
    opacity: 1;
  }
`;
